import React, {Component} from 'react';

class SidebarFooter extends Component {

  logout(){
    localStorage.removeItem("HC_TOKEN");
    //TODO attach to route - must be a better way to do this
    window.location.reload();      
  }

  render() {
    return (
       <div className="sidebar-footer">
          <button
            id="sidebarLogoutButton"
            onClick={()=>this.logout()}
          >Logout</button>       
       </div>
    );
  }
}

export default SidebarFooter;



// WEBPACK FOOTER //
// ./src/components/SidebarFooter/SidebarFooter.js